import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { EmailViewComponent } from './email-view/email-view.component';

@NgModule({
	declarations: [
    UnsubscribeComponent,
    EmailViewComponent
  ],
	imports: [SharedModule],
})
export class CustomerMarketingModule {}
